import React from 'react'
import {
  Field,
  Form,
  FormModal,
  FormSaveCancelButtons as FormSaveCancelButtonsCore,
  FormSaveButton as FormSaveButtonCore,
} from '@ztechapps/webui.form'

import { useHistory } from '@ztechapps/common.hook'
import type { Logistic, NextFunction } from '@ztechapps/common.contract'
import { AddNewButton } from './AddNewButton'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'
import { useAddLogistic } from '../../hooks/useAddLogistic'
import { CustomerSelectCreatable } from '@ztechapps/customer.webui'
import { routesDef } from '../../config/routes'

export type FormActionProps = {
  next?: NextFunction<Logistic>
  formButtons?: 'save-cancel' | 'save-only'
}

const useFormAction = ({ next }: FormActionProps) => {
  const { onAddRawLogistics } = useAddLogistic()

  const history = useHistory()

  const initialValues = {
    vendor: null,
    shipTo: null,
  }

  const validate = (values) => {
    const errors: any = {}

    if (!values?.vendor?._id) {
      errors.vendor = 'Required'
    }
    if (!values?.shipTo?._id) {
      errors.shipTo = 'Required'
    }

    return errors
  }

  const onSubmit = async (args) => {
    try {
      const { data, errors } = await onAddRawLogistics({
        input: {
          vendor: args?.vendor,
          shipTo: args?.shipTo,
        } as Logistic,
      })

      if (errors) throw errors
      const newLogistics = data?.createLogistic

      // if then navigate to necessary field is no error then navigate to
      const route = routesDef.LogisticItemPage.altPath({
        _id: newLogistics._id,
      })

      history.push(route)

      await next?.(newLogistics)
    } catch (e) {
      await next?.(null, e)
      throw e
    }
  }
  return { onSubmit, validate, initialValues }
}

export const AddForm = ({ next, formButtons }: FormActionProps) => {
  const { initialValues, validate, onSubmit } = useFormAction({ next })

  const finalFormButton = formButtons === 'save-only' ? <FormSaveButton /> : <FormSaveCancelButtons />

  return (
    <Form {...{ initialValues, validate, onSubmit, title: 'Add new purchase' }}>
      <Stack gap={2}>
        <FormContent />

        <HorizontalStack className="justify-content-end">{finalFormButton}</HorizontalStack>
      </Stack>
    </Form>
  )
}

export const AddFormModal = ({ next }: FormActionProps) => {
  const { initialValues, validate, onSubmit } = useFormAction({ next })
  return (
    <FormModal
      trigger={AddNewButton}
      initialValues={initialValues}
      validate={validate}
      onSubmit={onSubmit}
      title="Add new logistics"
    >
      <FormContent />
    </FormModal>
  )
}

const FormSaveCancelButtons = () => {
  return <FormSaveCancelButtonsCore saveText="Add new" />
}

const FormSaveButton = () => {
  return <FormSaveButtonCore text="Create" />
}

export const FormContent = () => {
  return (
    <Stack gap={3}>
      <Field
        name="vendor"
        component={CustomerSelectCreatable}
        label="Vendor"
        help="The vendor of this logistics"
        onChange
        autoFocus
      />

      <Field
        name="shipTo"
        component={CustomerSelectCreatable}
        label="Ship To"
        help="The 'ship to' of this logistics"
        onChange
      />
    </Stack>
  )
}
